// extracted by mini-css-extract-plugin
module.exports = {"caption-text":"Oops_caption-text__3fJeT"};